import { useState } from "react";

import LogoutModalUI from "./LogoutModal.ui.tsx";

interface UseLogoutModalProps {
  onLogout: () => void;
}

export const useLogoutModal = ({ onLogout }: UseLogoutModalProps) => {
  const [show, setShow] = useState(false);

  const open = () => setShow(true);
  const close = () => setShow(false);

  const handleLogout = () => {
    close();
    onLogout();
  };

  const modal = <LogoutModalUI show={show} handleClose={close} handleLogout={handleLogout} />;

  return { open, close, modal };
};
